"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  default: {
    padding: '5px 0',
    arrowColor: '#a9a9a9',
    labelColor: '#a9a9a9',
    labelMargin: '0 8px 0 0',
    fontSize: 10,
    buttonMinWidth: 20,
    buttonPadding: '3px 2px',
    buttonMargin: '0 5px 0 0',
    buttonBorderWidth: 1,
    buttonBorderColor: '#a9a9a9',
    buttonSelectedBorderColor: '#DA1157',
    buttonBorderRadius: '3px',
    buttonColor: '#a9a9a9',
    buttonSelectedColor: '#DA1157'
  }
};
exports.default = _default;